type Email = string;

export interface ShareResultSuccess {
  success: true;
}

export interface ShareResultError {
  success: false;
  reason: string;
  code?: ShareResultErrorCode;
}

export enum ShareResultErrorCode {
  PermissionNotFound = 'permission-not-found',
  PermissionHandledByAncestor = 'permission-handled-by-ancestor',
  TeamDomainNotEnabled = 'team-domain-not-enabled',
  /** Dirty in this case means that the user has uploaded files directly via the
   * Storage Web App having files with different OAuth provenance. This for
   * example breaks the public sharing in Google Drive. */
  FolderIsDirty = 'folder-is-dirty',
}

export type ShareResult = ShareResultSuccess | ShareResultError;
export type ShareResultTuple<T extends ShareResult = ShareResult> = [email: Email, result: T];
export type ShareResultErrorWithEmail = ShareResultError & { email: Email };

export interface SharingResultDto {
  domain: {
    add?: ShareResult;
    remove?: ShareResult;
  };
  groups: {
    add: Record<Email, ShareResult>;
    remove: Record<Email, ShareResult>;
  };
  publicAccess: {
    add?: ShareResult;
    remove?: ShareResult;
  };
  users: {
    add: Record<Email, ShareResult>;
    remove: Record<Email, ShareResult>;
  };
}
